import React from 'react';
import EventPublicWrapper from '../eventPublicWrapper';
import EventRegistration from '../../components/pages/eventRegistration';

async function action(params, props) {
  return {
    title: 'Event Sign-up',
    component: (
      <EventPublicWrapper>
        <EventRegistration eventId={params.params.id} />
      </EventPublicWrapper>
    ),
  };
}

export default action;
